export default [
  {
    companyName: "Redbubble",
    datesActive: "2022 - 2024",
    roles: [
      {
        teamTitle: "Supply Chain and Fulfillment Technology",
        teamRole: "Full Stack Engineer",
        datesActive: "Sep 2022 - July 2024",
        teamHighlights: [
          "Designed and implemented a dynamic order routing system using Ruby and Node.js, optimizing the supply chain and saving over AUD 1M annually.",
          "Built a React-based front-end platform enabling business users to configure and update routing system settings.",
          "Monitored and analyzed production environments using DataDog, troubleshooting and resolving performance issues.",
          "Facilitated the recruitment process and provided mentorship to junior engineers, fostering skill development and team growth.",
          "Led the end-to-end execution of large-scale projects, encompassing requirements gathering, backlog refinement, sprint planning, and retrospective analysis to drive continuous improvement.",
        ],
      },
    ],
  },
  {
    companyName: "Westpac Banking Corporation",
    datesActive: "2018 - 2022",
    roles: [
      {
        teamTitle: "Westpac Digital Platform",
        teamRole: "Back End Developer",
        datesActive: "Jan 2021 - Sep 2022",
        teamHighlights: [
          "Built and maintained over 20 APIs using Java and SpringBoot.",
          "Developed proxy and partner APIs connecting internal banking systems to external workflow services.",
          "Followed CI/CD processes for continuous testing and deployment.",
          "Optimized API performance, enhancing efficiency and reducing latency.",
        ],
      },
      {
        teamTitle: "Wealth Management Technology",
        teamRole: "Front End Developer",
        datesActive: "July 2020 - Jan 2021",
        teamHighlights: [
          "Designed and developed React components for wealth management tools.",
          "Migrated legacy user interfaces from vanilla JavaScript and Backbone.js to React.",
          "Created comprehensive test suites for UI components using Jasmine and Jest.",
        ],
      },
      {
        teamTitle: "Infrastructure & Asset Management",
        teamRole: "Full Stack Developer",
        datesActive: "Jan 2020 - July 2020",
        teamHighlights: [
          "Automated processes like firewall request management using PowerShell.",
          "Coordinated with service owners and external vendors (e.g., IBM) to integrate asset data into management tools.",
        ],
      },
      {
        teamTitle: "Financial Markets Technology",
        teamRole: "Front End Developer",
        datesActive: "Nov 2018 - Jan 2020",
        teamHighlights: [
          "Developed greenfield single-page applications using React.",
          "Designed and implemented Redux workflows for efficient state management.",
          "Integrated REST APIs to retrieve, process, and display data for user interaction.",
        ],
      },
    ],
  },
];
